import axios from "axios";
import endpoints from "../utils/endpoints";
import { accessToken } from "../utils/token";
import encryptData from "../utils/encrypt";
import fileDownload from "js-file-download";


const getCategoryByEventId = async (params: any) => {
  const url = endpoints.CATEGORY;

  const { data: response } = await axios.get(url, {
    headers: {
      Authorization: accessToken,
    },
    params,
  });

  return response;
};

const getCategoryListByEventId = async (params: any) => {
  const url = endpoints.CATEGORY + "/list";

  const { data: response } = await axios.get(url, {
    headers: {
      Authorization: accessToken,
    },
    params,
  });

  return response;
};

const getCategoryByEventIdPublic = async (params: any) => {
  const url = endpoints.PUBLIC_CATEGORY;

  const { data: response } = await axios.get(url, {
    headers: {
      Authorization: accessToken,
    },
    params,
  });

  return response;
};

const viewCategoryDetail = async (id: any) => {
  const url = endpoints.CATEGORY_DETAIL(id);
  const { data: response } = await axios.get(url, {
    headers: {
      Authorization: accessToken,
    },
  });
  return response;
};

const updateCategory = async (params: any) => {
  const url = endpoints.CATEGORY + `/${params.id}`;

  const { data: response } = await axios.put(url, params, {
    headers: {
      Authorization: accessToken,
    },
  });

  return response;
};

const createCategory = async (params: any) => {
  const url = endpoints.CATEGORY;
  const { data: response } = await axios.post(url, params, {
    headers: {
      Authorization: accessToken,
    },
  });

  return response;
};

const deleteCategory = async (id: number) => {
  const url = endpoints.CATEGORY + `/${id}`;

  const { data: response } = await axios.delete(url, {
    headers: {
      Authorization: accessToken,
    },
  });
  return response;
};

const checkout = async (params: any) => {
  const url = endpoints.CATEGORY + "/checkout";
  const { data: response } = await axios.post(
    url,
    { data: encryptData(params) },
    {
      headers: {
        Authorization: accessToken,
      },
    }
  );
  
  // Response includes: { success: boolean, order_id: string, payment_url: string }
  return response;
};

const createInvitation = async (params: any) => {
  const url = endpoints.CATEGORY + "/invitation";
  const { data: response } = await axios.post(url, params, {
    headers: {
      Authorization: accessToken,
    },
  });

  return response;
};

const generateTicketLinks = async (data: {
  category_id: number;
  total_ticket: number;
}) => {
  const url = endpoints.CATEGORY + "/generate-ticket-links";
  const { data: response } = await axios.post(url, data, {
    headers: {
      Authorization: accessToken,
    },
  });

  return response;
};

const downloadInvitations = async (category_id: string) => {
  const url = endpoints.CATEGORY + `/${category_id}/download-invitations`;
  const { data: response } = await axios.get(url, {
    headers: {
      Authorization: accessToken,
      ContentType:
        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    },
    responseType: "arraybuffer",
  });

  const blob = new Blob([response], {
    type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
  });

  fileDownload(blob, `invitations-${category_id}.xlsx`);
  return blob
};

const categoryService = {
  getCategoryByEventId,
  getCategoryByEventIdPublic,
  viewCategoryDetail,
  updateCategory,
  createCategory,
  deleteCategory,
  checkout,
  createInvitation,
  generateTicketLinks,
  downloadInvitations,
  getCategoryListByEventId,
};

export default categoryService;
